import { h } from 'preact'
import { RouteParam, getValgtype, getStringOrThrow } from '../../../lib/simple-routing/params'
import { AppRoute } from '../route'
import { AppStore } from '../../store'
import { fetchGrunndata } from '../../store/actions/grunndata'
import { fetchDataForWidget } from '../../store/actions'
import { WidgetFrame } from '../../components/frames/WidgetFrame/WidgetFrame'
import { HasOppslutning } from '../../components/shared/HasOppslutning/HasOppslutning'
import { ResultatParatiContainer } from '../../components/resultater/ResultatParti/Resultat'
import { isPartiValgResultat } from '../../domain'
import { PastanderParti } from '../../components/moduler/PastanderParti/PastanderParti'

export const pastanderPartiRoute: AppRoute = {
  path: `/valg/2019/resultat/widget/:locale/partipastander/:valgtype(kommune|fylke)/:id`,
  widget: true,
  widgetTitle: (params: RouteParam[]) => {
    const valgtype = getValgtype(params)
    return `Pastander – ${valgtype}`
  },
  onLoad: async (store: AppStore) => {
    return store.dispatch(fetchGrunndata())
  },
  onRouteChanged: async (store: AppStore, params: RouteParam[]) => {
    const paramId = getStringOrThrow(params, 'id')
    const valgtype = getValgtype(params)

    const grunndata = store.getState().grunndata
    const parti = grunndata.parti.find(({ id }) => id === paramId)

    if (!parti) {
      throw Error('Fant ikke parti')
    }

    return store.dispatch(fetchDataForWidget(parti, valgtype))
  },
  render: params => {
    return (
      <WidgetFrame>
        <ResultatParatiContainer type="auto">
          {(resultat, parti, locale) => {
            if (isPartiValgResultat(resultat)) {
              throw new Error(
                'Kan ikke vise påstander for partier som stiller flere steder ' + parti.id
              )
            } else {
              const { partier = [], geografi, pastander } = resultat
              return (
                <HasOppslutning partier={partier}>
                  <HasOppslutning partier={partier}>
                    <PastanderParti
                      geografi={geografi}
                      parti={parti}
                      partiresultat={partier[0]}
                      pastander={pastander}
                    />
                  </HasOppslutning>
                </HasOppslutning>
              )
            }
          }}
        </ResultatParatiContainer>
      </WidgetFrame>
    )
  }
}
